document.addEventListener('DOMContentLoaded', function () {
  function closeDropdown(dropdown) {
    dropdown.classList.remove('is-open');
    var toggle = dropdown.querySelector('[data-dropdown-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }
  function openDropdown(dropdown) {
    dropdown.classList.add('is-open');
    var toggle = dropdown.querySelector('[data-dropdown-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var open = mobileMenu.hidden;
      mobileMenu.hidden = !open;
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) {
        // Menu is closing — collapse any expanded dropdown accordions inside it.
        mobileMenu.querySelectorAll('[data-dropdown].is-open').forEach(closeDropdown);
      }
    });
  }

  // Click-to-toggle is only wired up for the mobile accordion. Desktop relies
  // purely on CSS (:hover / :focus-within) — see layout.css.
  document.querySelectorAll('[data-mobile-menu] [data-dropdown]').forEach(function (dropdown) {
    var toggle = dropdown.querySelector('[data-dropdown-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var isOpen = dropdown.classList.contains('is-open');
      document.querySelectorAll('[data-dropdown].is-open').forEach(function (open) {
        if (open !== dropdown) closeDropdown(open);
      });
      if (isOpen) {
        closeDropdown(dropdown);
      } else {
        openDropdown(dropdown);
      }
    });
  });

  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-dropdown].is-open').forEach(function (dropdown) {
      if (!dropdown.contains(e.target)) closeDropdown(dropdown);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-dropdown].is-open').forEach(closeDropdown);
    }
  });

  var thumbs = document.querySelectorAll('.sb-product__thumbs img');
  var mainImage = document.getElementById('ProductMainImage');
  if (mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainImage.src = thumb.getAttribute('data-full');
        mainImage.dataset.zoom = thumb.getAttribute('data-zoom');
      });
    });
  }

  // Generic modal: [data-modal-open] triggers show the <dialog> matching its
  // value. If the trigger also has [data-modal-source], the element with that
  // id's data-zoom (falling back to its currentSrc/src) is copied into the
  // modal's [data-modal-image] before opening — used for the product image
  // zoom, but works for any future trigger/source pair.
  document.querySelectorAll('[data-modal-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var modal = document.getElementById(trigger.getAttribute('data-modal-open'));
      if (!modal || typeof modal.showModal !== 'function') return;

      var sourceId = trigger.getAttribute('data-modal-source');
      if (sourceId) {
        var source = document.getElementById(sourceId);
        var modalImg = modal.querySelector('[data-modal-image]');
        if (source && modalImg) {
          modalImg.src = source.dataset.zoom || source.currentSrc || source.src;
          modalImg.alt = source.alt || '';
        }
      }
      modal.showModal();
    });
  });

  document.querySelectorAll('[data-modal]').forEach(function (modal) {
    modal.querySelectorAll('[data-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { modal.close(); });
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) modal.close();
    });
  });

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = track ? track.querySelectorAll('[data-carousel-slide]') : [];
    var dots = carousel.querySelectorAll('[data-carousel-dot]');
    if (!track || slides.length < 2) return;

    carousel.querySelectorAll('[data-carousel-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
    });
    carousel.querySelectorAll('[data-carousel-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });
    });

    if (dots.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = Array.prototype.indexOf.call(slides, entry.target);
          dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (slide) { observer.observe(slide); });
    }
  });
});
